import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* TYPES */
export var DEFAULT_SLAVE_COORDS = {
  top: '0',
  left: '0'
};
var DEFAULT_OFFSET = 8;
export var getScrolls = function getScrolls() {
  return {
    scrollTop: document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0,
    scrollLeft: document.documentElement && document.documentElement.scrollLeft || document.body && document.body.scrollLeft || 0
  };
};

var getSlaveCoords = function getSlaveCoords(_ref) {
  var masterCoords = _ref.masterCoords,
      slaveCoords = _ref.slaveCoords,
      pos = _ref.pos,
      alignedOnEdge = _ref.alignedOnEdge;
  var map = {
    bottom: {
      top: masterCoords.top + masterCoords.height,
      left: masterCoords.left + (alignedOnEdge ? 0 : masterCoords.width / 2 - slaveCoords.width / 2)
    },
    top: {
      top: masterCoords.top - slaveCoords.height,
      left: masterCoords.left + (alignedOnEdge ? 0 : masterCoords.width / 2 - slaveCoords.width / 2)
    },
    left: {
      top: masterCoords.top + (alignedOnEdge ? 0 : masterCoords.height / 2 - slaveCoords.height / 2),
      left: masterCoords.left - slaveCoords.width
    },
    right: {
      top: masterCoords.top + (alignedOnEdge ? 0 : masterCoords.height / 2 - slaveCoords.height / 2),
      left: masterCoords.left + masterCoords.width
    }
  };
  return map[pos];
};

var getAdjustedPositionMap = function getAdjustedPositionMap(_ref2) {
  var resultCoords = _ref2.resultCoords,
      slaveCoords = _ref2.slaveCoords,
      masterCoords = _ref2.masterCoords,
      pos = _ref2.pos;

  var _getScrolls = getScrolls(),
      scrollTop = _getScrolls.scrollTop,
      scrollLeft = _getScrolls.scrollLeft;

  var map = {
    top: {
      position: 'bottom',
      condition: resultCoords.top < scrollTop
    },
    bottom: {
      position: 'top',
      condition: resultCoords.top + slaveCoords.height > scrollTop + window.innerHeight && (masterCoords ? masterCoords.top <= scrollTop + window.innerHeight : true)
    },
    left: {
      position: 'right',
      condition: resultCoords.left < scrollLeft
    },
    right: {
      position: 'left',
      condition: resultCoords.left + slaveCoords.width > scrollLeft + window.innerWidth && (masterCoords ? masterCoords.left <= scrollLeft + window.innerWidth : true)
    }
  };
  return map[pos];
};

var getAdjustedCoords = function getAdjustedCoords(_ref3) {
  var resultCoords = _ref3.resultCoords,
      slaveCoords = _ref3.slaveCoords,
      pos = _ref3.pos;

  var _getScrolls2 = getScrolls(),
      scrollTop = _getScrolls2.scrollTop,
      scrollLeft = _getScrolls2.scrollLeft;

  var leftOffset = resultCoords.left - (resultCoords.left + slaveCoords.width + DEFAULT_OFFSET - (scrollLeft + window.innerWidth));
  var topOffset = resultCoords.top - (resultCoords.top + slaveCoords.height + DEFAULT_OFFSET - (scrollTop + window.innerHeight));
  var map = {
    top: {
      left: resultCoords.left < scrollLeft || slaveCoords.width > window.innerWidth ? scrollLeft + DEFAULT_OFFSET : resultCoords.left + slaveCoords.width > scrollLeft + window.innerWidth ? leftOffset : resultCoords.left,
      top: resultCoords.top
    },
    bottom: {
      left: resultCoords.left < scrollLeft || slaveCoords.width > window.innerWidth ? scrollLeft + DEFAULT_OFFSET : resultCoords.left + slaveCoords.width > scrollLeft + window.innerWidth ? leftOffset : resultCoords.left,
      top: resultCoords.top
    },
    left: {
      left: resultCoords.left,
      top: resultCoords.top < scrollTop || slaveCoords.height > window.innerHeight ? scrollTop + DEFAULT_OFFSET : resultCoords.top + slaveCoords.height > scrollTop + window.innerHeight ? topOffset : resultCoords.top
    },
    right: {
      left: resultCoords.left,
      top: resultCoords.top < scrollTop || slaveCoords.height > window.innerHeight ? scrollTop + DEFAULT_OFFSET : resultCoords.top + slaveCoords.height > scrollTop + window.innerHeight ? topOffset : resultCoords.top
    }
  };
  return map[pos];
};

export var getSlaveCoordsAndPosition = function getSlaveCoordsAndPosition(_ref4) {
  var masterCoords = _ref4.masterCoords,
      slaveCoords = _ref4.slaveCoords,
      pos = _ref4.pos,
      alignedOnEdge = _ref4.alignedOnEdge;
  var coords = DEFAULT_SLAVE_COORDS;
  var position = pos;
  var resultCoords = getSlaveCoords({
    masterCoords: masterCoords,
    slaveCoords: slaveCoords,
    pos: pos,
    alignedOnEdge: alignedOnEdge
  });
  var adjustedPositionMap = getAdjustedPositionMap({
    resultCoords: resultCoords,
    slaveCoords: slaveCoords,
    masterCoords: masterCoords,
    pos: pos
  });

  if (adjustedPositionMap.condition) {
    position = adjustedPositionMap.position;
    resultCoords = getSlaveCoords({
      masterCoords: masterCoords,
      slaveCoords: slaveCoords,
      pos: position,
      alignedOnEdge: alignedOnEdge
    });
  }

  var adjustedCoords = getAdjustedCoords({
    resultCoords: resultCoords,
    slaveCoords: slaveCoords,
    pos: position
  });
  return {
    coords: _objectSpread({}, coords, {
      top: "".concat(adjustedCoords.top, "px"),
      left: "".concat(adjustedCoords.left, "px")
    }),
    position: position
  };
};
export var getElementCoords = function getElementCoords(element) {
  var rect = element.getBoundingClientRect();

  var _getScrolls3 = getScrolls(),
      scrollTop = _getScrolls3.scrollTop,
      scrollLeft = _getScrolls3.scrollLeft;

  return {
    top: scrollTop + rect.top,
    left: scrollLeft + rect.left,
    width: rect.width,
    height: rect.height
  };
};